import axios from 'axios';

// eslint-disable-next-line no-undef
const apiUrl = process.env.REACT_APP_API_URL;

export const get = async (url) => axios.get(apiUrl + url);
export const post = async (url, data, config) => axios.post(apiUrl + url, data, config);
export const put = async (url, body) => axios.put(apiUrl + url, body);
export const patch = async (url, body) => axios.patch(apiUrl + url, body);
